import * as t from 'io-ts';

import {makeApiSerializableType, RLazyTeammateIdRef} from './apiTypes';

/*
 * Runtime type.
 */

export const RReminder = t.readonly(
  t.intersection([
    t.type({
      teammateId: RLazyTeammateIdRef,
      remindAt: t.Integer,
      isTeamReminder: t.boolean,
    }),
    t.partial({
      canceledById: t.union([t.Integer, t.undefined]),
      isCanceledByActivity: t.union([t.boolean, t.undefined]),
    }),
  ]),
);

/*
 * Type.
 */

export interface ReminderModel extends t.TypeOf<typeof RReminder> {}

/*
 * IOs methods.
 */

export function parseReminder(src: any): ReminderModel {
  return {
    teammateId: src.teammate_id,
    remindAt: src.until,
    isTeamReminder: src.is_team_snooze || false,
    canceledById: src.canceled_by_message_id,
    isCanceledByActivity: src.canceled_by_activity,
  };
}

export function serializeReminder(reminder: ReminderModel): any {
  return {
    teammate_id: reminder.teammateId,
    until: reminder.remindAt,
  };
}

/*
 * API type.
 */

export const ApiReminder = makeApiSerializableType('reminder', RReminder, parseReminder, serializeReminder);
